import { Pipe, PipeTransform, Inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { FORMATS_CONFIGURATION_TOKEN, FormatConfiguration } from '../tokens';

@Pipe({
  name: 'statusShow'
})
export class StatusPipe implements PipeTransform {
  statuses: { name: string; colour: string }[];

  constructor(
    @Inject(FORMATS_CONFIGURATION_TOKEN) configuration: FormatConfiguration,
    private sanitizer: DomSanitizer
  ) {
    this.statuses = configuration.statuses;
  }

  transform(value: string, css?: any): SafeHtml {
    if (!value) {
      return;
    }
    const type = this.getBadgeType(value);
    return this.sanitizer.bypassSecurityTrustHtml(`<span
    class="badge badge-${type} ${css}"
    >${value}</span`);
  }

  getBadgeType(value: string): any {
    const status = this.statuses.find(
      s =>
        s.name.toUpperCase().replace(/ /, '_') ===
        value.toUpperCase().replace(/ /, '_')
    );
    return status ? status.colour : 'secondary';
  }
}
